import React, { Component } from "react";
import PropTypes from "prop-types";
import { AnimatedView, StatsCard, WorkProgress } from "../../components";
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert,
  Panel,
  PanelGroup  
} from 'react-bootstrap';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';
import { createHashHistory } from 'history';
import loader from '../../style/loader/loader.scss';
import { Link } from "react-router-dom";
import isEmpty from 'lodash.isempty';
import { CSVLink } from "react-csv";
import Picky from "react-picky";
import "react-picky/dist/picky.css"; // Include CSS
  
const history = createHashHistory();

let isLoading='false', csvData = [];
class RevenueSite extends Component {
  constructor(props){
    super(props);
    this.state={
      show: false,
      alertMessage:'',
      disabled: false,
      monthyeardata:[],
      groupedData:[],
      monthdata:'',
      msgType:'',
      siteID:'',
      month:'',
      csvData: "",
      showValue: "",
      reportData: "",
      selectedSites: [],
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleSiteChange = this.handleSiteChange.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }
  
  handleShow() {
    this.setState({ show: true });
  }

  handleMonthChange(e){
    if(`${e.target.name}Error` !== ''){
      this.setState({[`${e.target.name}Error`]:''})
    }
    this.setState({[e.target.name]:e.target.value})      
  }

  handleSiteChange(event, data) {
    this.setState({
      selectedSites: event
    });
  }   

  componentWillMount(){
    const {
      actions: { getMonth }
    } = this.props;
    getMonth();
    const {
      actions: { getSiteList }
    } = this.props;
    getSiteList({page:0});
    isLoading='true';
  }

  componentWillReceiveProps(nextProps){

    if(this.props.error !== nextProps.error){
      if(nextProps.error){
        this.handleShow();
        isLoading="false";           
      }
    } 
     

    if(this.props.MonthData !== nextProps.MonthData){
      if(!isEmpty(nextProps.MonthData)){
        this.setState({monthdata: nextProps.MonthData})
        let month= nextProps.MonthData;
        const postData={
          selectMonth: month[0]
        }
        const {
          actions: { getRevenueSite }
        } = this.props;
        getRevenueSite(postData);
      }
    }

    if (this.props.reportData !== nextProps.reportData) {
      if (nextProps.reportData) {
        isLoading = "false";
        this.setState({ reportData: nextProps.reportData });
        this.handleExport(nextProps.reportData);
      }
    }         
   // console.log('nextProps.siteList',nextProps.siteList)
   //  console.log('this.props.siteList',this.props.siteList)  

    if(this.props.siteList !== nextProps.siteList){
      if(nextProps.siteList){
        this.setState({
          sitedata: nextProps.siteList,
          siteList: nextProps.siteList
        })
      }
    }       

    if(nextProps.message){
      this.handleShow();
      this.setState({alertMessage:nextProps.message, msgType:nextProps.alertType})
    }
     
  }


  handleSubmit(e){
    e.preventDefault();
    let postData;
    let seletedIDs = this.state.selectedSites.map((sVal, index) => sVal.siteID);
    isLoading = 'true';
    postData = {
      selectMonth: this.state.month,
      siteID: seletedIDs
    }
    const {
      actions: { getRevenueSite }
    } = this.props;
    getRevenueSite(postData);
  }

  handleExport = data => {
    csvData = [
      [
        'Site Name',
        'Credit Card Sale Amount',
        'Store Credits Used',
        'Promo Codes Used',
        'Gross Sale',
        'Refunds',
        'Adjusted Gross',
        'Net To Site',
        'Shipping',
        'Credit Card Fees',
        'Monthly Fees',
        'Minimum Monthly Fees',
        'DDB Commission %',
        'DDB Commission',
        'DDB Commission Type',
        'Stripe Commission',
        'Invoice Amount',
      ]
    ];
    {data &&
      data.data.map((data, index) =>
        csvData.push([
          data.site_name,
          data.credit_card_sale,
          data.site_credits,
          data.promos,
          data.gross_sale,
          data.refund_amount,
          data.adjusted_gross_sale,
          data.net_to_site,
          data.shipping_to_site,
          data.credit_card_fee,
          data.monthlyFee,
          data.minMonthlyFee,         
          data.ddb_commission_per,
          data.ddb_commission,
          data.commissionType,
          data.application_fee_amount,
          data.invoiceAmount,
          ])
        )
    }
    this.setState({ csvData: csvData });
  };

  showData = (value) => {
    this.setState({showValue: value});
  }

  hideData = () => {
    this.setState({showValue: ''});
  }

  render() {
    if(this.props.error){
     isLoading="false";
    }

    const { siteList, selectedSites } = this.state;
    let siteNamefromID = this.state.selectedSites.map((sVal, index) => sVal.siteName);
         
    return (
      <div className="col-lg-12 add-sub-admin">       
      <div className="row">
      <div className="col-xs-12">
      {this.state.show &&
        this.state.alertMessage !== "" && (
          <div className="col-lg-12">
          <Alert
          bsStyle={this.state.msgType}
          onDismiss={this.handleDismiss}
          >
          <strong>{this.state.msgType}:</strong>{" "}
          {this.state.alertMessage}
          </Alert>
          </div>
      )}
      </div>
      </div>
      <form onSubmit={this.handleSubmit}>
        <div className="panel">
          <header className="panel-heading">Revenue By Site</header>
            <div className="panel-body">
              <Row>
                <Col md={6} xs={12}>
                <FormGroup controlId="site">
                <ControlLabel>Site</ControlLabel>     
                <Picky
                numberDisplayed={3}
                options={siteList}
                value={selectedSites}
                valueKey="siteID"
                labelKey="siteName"
                multiple={true}
                includeSelectAll={true}
                includeFilter={true}
                onChange={this.handleSiteChange}
                dropdownHeight={200}
                />
                </FormGroup>             
                </Col>
                <Col md={4} xs={12}>
                <FormGroup controlId="monthyear">
                <ControlLabel>Month</ControlLabel>
                <FormControl componentClass="select" style={{borderColor:this.state.monthyearError}} name="month" onChange={this.handleMonthChange.bind(this)} value={this.state.month}>
                <option value="">Select Month</option>
                {(!isEmpty(this.state.monthdata)) && 
                  this.state.monthdata.map((month, index) => 
                    <option key={index} value={month}>{month}</option>
                    )
                }
                </FormControl>
                </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={12} xs={12}>
                  <Button
                  bsStyle="info"
                  type="submit"
                  id="saveButton"
                  disabled={this.state.disabled}
                  >
                  Submit
                  </Button>            
                </Col>
              </Row>
            </div>
        </div> 
      </form>      
      {(isLoading =='true') ? 
        <div className="loader">
        <p className="loading-message">
        <i>
        Loading...
        </i>
        </p>
        <div className="spinner">
        <div className="dot1"></div>
        <div className="dot2"></div>
        </div>
        </div> : ''
      }
      <div className="panel">      
          <div className="panel-body table-responsive">
            <span className="pull-right">
              {this.state.csvData ? (
                <CSVLink
                data={this.state.csvData}
                filename={"revenue-by-site-report.csv"}
                className="btn btn-danger"
                >
                Export CSV
                </CSVLink>
                ) : null}
            </span>
            <table className="table table-hover table-bordered customth">
              <thead>
                <tr>
                  <th colSpan="12">Data for the month: {this.state.month}</th>
                </tr>
                <tr>
                  <th>Site Name</th>
                  <th>Credit Card Sale Amount</th> 
                  <th>Store Credits Used</th> 
                  <th>Promo Codes Used</th> 
                  <th>Gross Sale</th>
                  <th>Refunds</th>
                  <th>Adjusted Gross</th>
                  <th>Net To Site</th>
                  <th>Shipping </th>
                  <th>Credit Card Fees </th>
                  <th>Monthly Fees </th>
                  <th>Minimum Monthly Fee </th>
                  <th>DDB Commission % </th> 
                  <th>DDB Commission </th> 
                  <th>DDB Commission Type </th>
                  <th>Stripe Commission</th>
                  <th>Invoice Amount </th>
                </tr>
              </thead>
              <tbody>                       
                {this.state.reportData.data ?
                  this.state.reportData.data.map((data, index) =>
                    <tr key={index}>
                    <td>{data.site_name}</td>
                    <td>{data.credit_card_sale}</td>
                    <td>{data.site_credits}</td>
                    <td>{data.promos}</td>
                    <td>{data.gross_sale}</td>
                    <td>{data.refund_amount}</td>
                    <td>{data.adjusted_gross_sale}</td>
                    <td>{data.net_to_site}</td>
                    <td>{data.shipping_to_site}</td>
                    <td>{data.credit_card_fee}</td>
                    <td>{data.monthlyFee}</td>
                    <td>{data.minMonthlyFee}</td>
                    <td>{data.ddb_commission_per}</td>
                    <td>{data.ddb_commission}</td>
                    <td>{data.commissionType}</td>
                    <td>{data.application_fee_amount}</td>
                    <td>{data.invoiceAmount}</td>
                    </tr>
                    )
                  :
                  <tr><td colSpan="12">Data Not Found</td></tr>
                }  
              </tbody>
            </table>
        </div>
      </div>       
    </div>      
    );
  }
}
export default RevenueSite;



// WEBPACK FOOTER //
// ./src/app/views/revenueSite/RevenueSite.js